import { useFetch } from "~vue/api";
import { logError, logUserInteraction } from "~vue/utils/logUtils";
import { computed, ref } from "vue";

const V1_URL = (hashid) => `/accounts/coaching_session/${hashid}`;

/**
 * Composable to delete a past conversation.
 *
 * @param {Object} args
 * @param {Function} args.onResponseCallback - Called after a successful delete.
 * @param {string} args.source - Source identifier, used for analytics.
 */
export const useDeletePastConversation = ({ onResponseCallback, source }) => {
    const activeUrl = ref(null);
    const url = computed(() => activeUrl.value);

    const { execute, error, onFetchError, onFetchResponse } = useFetch(url, { immediate: false }).delete();
    onFetchError((fetchError) => logError(fetchError));
    onFetchResponse(() => onResponseCallback?.());

    // execute() clears error before each request, so this resets itself on a retry.
    const deleteError = computed(() => (error.value ? "We could not delete that conversation. Please try again." : null));
    const dismissDeleteError = () => {
        error.value = null;
    };

    const deletePastConversation = async ({ kind, hashid, uuid }) => {
        activeUrl.value = V1_URL(hashid);
        logUserInteraction("delete_conversation", { kind, hashid, uuid, ...(source && { source }) }, uuid);
        await execute();
    };

    return {
        deletePastConversation,
        deleteError,
        dismissDeleteError,
    };
};
